import "./EvaporativeCooling.module.css";
import Header from "@/reusable_sections/Header";
import EvaporativeHero from "./sections/EvaporativeHero";
import EvaporativeCooling from "./sections/EvaporativeCooling";
import Benefits from "./sections/Benefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function EvaporativeCoolingPage() {
  return <div>
      <Header />
      <EvaporativeHero />
      <EvaporativeCooling />
      <Benefits />
      <CallToAction />
      <Footer />
    </div>;
}